import { render, staticRenderFns } from "./IconInformation.vue?vue&type=template&id=62292859&"
import script from "./IconInformation.vue?vue&type=script&lang=ts&"
export * from "./IconInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports